/**
 * FilterButton
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
/** Main description for this component. */
var FilterButton = function (_a) {
    var text = _a.text, id = _a.id, isActive = _a.isActive, onClick = _a.onClick, props = __rest(_a, ["text", "id", "isActive", "onClick"]);
    return (React.createElement("button", __assign({ onClick: onClick, id: id, role: "tab", className: clsx('filter-button border-2 z-10 relative bg-secondary text-primary-2 border-borderWidth border-borderColor px-4 pt-2 pb-2 rounded-lg rounded-b-none text-medium border-b-0 mr-1', isActive && 'filter-button--active') }, props), text));
};
export default FilterButton;
